import { Injectable, NgZone, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Commands } from '../commands/commands';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export abstract class Events {

  private ng_zone = inject(NgZone);
  private EVENTSOURCE: EventSource | null = null;
  protected readonly ENDPOINT: string;

  constructor(
    protected commands: Commands,
    game_name: string
  ) {
    this.ENDPOINT = `${environment.base_url}/games/api/${game_name}/`;
  }

  public connect(): Observable<any> {

    this.resetConnection(); // disconnects to previous connections, if any

    return new Observable<void>(observer => {

      // assign eventsource

      const client_id = this.commands.getClientId();
      const endpoint = `${this.ENDPOINT}?client_id=${client_id}`;
      
      this.EVENTSOURCE = new EventSource(endpoint);

      // define success and error handlers

      const handshakeHandler = (message: MessageEvent) => {

        this.ng_zone.run(() => {

          const data = JSON.parse(message.data);

          if (data.status === 'success')
            observer.next(data);

          else if (data.status === 'failure')
            observer.error(data);

        });

      }

      const errorHandler = (error: Event) => {

        this.ng_zone.run(() => {
          observer.error({ status: 'error', error });
        });

      };

      // declare event listeners

      this.EVENTSOURCE.addEventListener('handshake', handshakeHandler);
      this.EVENTSOURCE.addEventListener('error', errorHandler);

      return () => {

        this.EVENTSOURCE?.removeEventListener('handshake', handshakeHandler);
        this.EVENTSOURCE?.removeEventListener('error', errorHandler);

      }

    });

  }

  protected resetConnection(): void {

    if (!this.EVENTSOURCE) return;

    // disconnect
    this.EVENTSOURCE?.close();
    this.EVENTSOURCE = null;

  }

  protected on(event: string): Observable<any> {

    return new Observable(observer => {

      // check on event source

      if (!this.EVENTSOURCE) {

        observer.error("Can't receive SSE messages. Connection not enstablished.");
        return;
        
      }

      // define event handler

      const eventHandler = (message: MessageEvent) => {

        this.ng_zone.run(() => {
          observer.next(JSON.parse(message.data));
        });
        
      };

      // declare event listener

      this.EVENTSOURCE.addEventListener(event, eventHandler);
      
      return () => {
        this.EVENTSOURCE?.removeEventListener(event, eventHandler);
      };

    });

  }

  ngOnDestroy(): void {
    this.resetConnection();
  }

}
